export default {
    "确认": "확인",
    "取消": "취소",
    "选择语言": "언어 선택",
    "切换语言成功": "언어 전환 성공",
    "首页": "홈",
    "申购": "신청",
    "团队": "팀",
    "资金管理": "자금 관리",
    "资金明细": "자금 내역",
    "我的订单": "내 주문",
    "订单详情": "주문 상세",
    "没有更多了": "더 이상 없음",
    "加载中": "로딩 중",
    "交易进行中,请勿进行其他操作": "거래 중입니다. 다른 작업을 수행하지 마세요",
    "代币价格": "토큰 가격",
    "收益概览": "수익 개요",
    "申购收益": "신청 수익",
    "分享收益": "공유 수익",
    "官方网站": "공식 웹사이트",
    "官网": "공식 사이트",
    "电报": "텔레그램",
    "推特": "트위터",
    "白皮书": "백서",
    "申购金额": "신청 금액",
    "请输入入金金额": "입금 금액을 입력해주세요",
    "快捷申购": "빠른 신청",
    "申购比例": "신청 비율",
    "赠币数量": "증정 토큰 수량",
    "立即申购": "즉시 신청",
    "更多": "더 보기",
    "订单": "주문",
    "分红中": "배당 중",
    "已完成": "완료됨",
    "累计分红": "누적 배당",
    "申购信息": "신청 정보",
    "兑换数量": "교환 수량",
    "开始时间": "시작 시간",
    "提现成功": "출금 성공",
    "订单编号": "주문 번호",
    "团队数据总览": "팀 데이터 총覽",
    "我的推广链接": "내 홍보 링크",
    "复制": "복사",
    "分享此链接邀请好友加入团队，获取推广奖励": "이 링크를 공유하여 친구를 팀에 초대하고 홍보 보상을 받으세요",
    "团队业绩": "팀 실적",
    "当前等级": "현재 등급",
    "今日收益": "오늘의 수익",
    "团队用户": "팀 사용자",
    "有效团队": "유효한 팀",
    "有效用户": "유효한 사용자",
    "无效团队": "무효한 팀",
    "直推用户": "직접 추천 사용자",
    "有效直推": "유효한 직접 추천",
    "无效直推": "무효한 직접 추천",
    "资产余额数据概览": "자산 잔액 데이터 개요",
    "提现": "출금",
    "选中币种": "선택한 화폐",
    "提现数量": "출금 수량",
    "确认提现": "출금 확인",
    "分红收入": "배당 수입",
    "直推奖励": "직접 추천 보상",
    "团队奖励": "팀 보상",
    "全部": "전체",
    "收入": "수입",
    "支出": "지출",
    "请输入正确的金额": "正しい金額を入力してください",
    "申购成功": "신청 성공",
    "申购失败": "신청 실패",
    "提现成功": "출금 성공",
    "提现失败": "출금 실패",
    "提现信息": "출금 정보",
    "提现币种": "출금 화폐",
    "提现数量": "출금 수량",
    "请选择币种": "화폐를 선택해주세요",
    "钱包余额不足": "지갑 잔액이 부족합니다",
    "余额不足": "잔액이 부족합니다",

    "提现手续费": "출금 수수료",
    "间推奖励": "간접 추천 보상",
    "团队奖励": "팀 보상",
    "提现失败退还": "출금 실패 환불",
    "ido申购": "IDO 신청",
    "ido申购赠送": "IDO 신청 증정",
    "链式去中心化全球点火网络": "체인 분산형 글로벌 점화 네트워크",
    "长期价值": "장기 가치",
    "智能涌现": "지능적 출현",
    "协议永生": "프로토콜 영생",
    "立即进入": "즉시 진입",
    "大区累计业绩": "대분기 누적 성과",
    "小区累计业绩": "소분기 누적 성과",
    "复制成功": "복사 성공",
    "复制失败":"복사 실패",
    "暂无数据": "데이터가 없습니다",
    "平级奖励": "동급 보상",
    "申购金额不能小于":"신청 금액은 최소  이상이어야 합니다",
}